import _ from 'underscore';
import dayjs from '../../../shared/services/dayjs.js';
import { schichtenService } from './services/SchichtenService.js';
import { stammdatenService } from './services/StammdatenService.js';
import { datumService } from './services/DatumService.js';
import { zeigeKleineNachricht } from './systemNachricht.js';
import { zeigeDienstplan, erstelleToolbarVorlagenSelect } from './dienstplan.js';
import { renderAktiveView } from './views/viewSwitcher.js';
import { debounce } from './util.js';
import { erstelleZeitblockTabelle, offenerZeitblock, zeitblockAnzahl } from './zeitblock.js';
import { speichereSchichtVorlage, loescheSchichtVorlage, initArtSegment, initFarbSwatches } from './schichtEditor.js';
import { renderVorlagenPicker, wendeVorlageAn } from './components/vorlagenPicker.js';
import SystemDialogService from '../../../shared/services/systemDialogService.js';
import { Egfz } from '../../../shared/services/Egfz.js';

const debounceUpdateTagesnotiz = debounce(async (args) => {
    await updateTagesNotiz(args[0]);
});

// Toolbar Funktionen
const toolbarFun = {};
toolbarFun.sortNamen = sortNamen;
toolbarFun.sortRank = sortRank;
toolbarFun.sortPersonalnummer = sortPersonalnummer;
toolbarFun.kopiereDienstplan = kopiereDienstplan;
toolbarFun.wechsleBereich = wechsleBereich;
toolbarFun.wechsleWoche = wechsleWoche;
toolbarFun.erstelleSchichtVorlagenInputFeld = erstelleSchichtVorlagenInputFeld;
toolbarFun.schichtenFreigebenWoche = schichtenFreigebenWoche;
toolbarFun.schichtenFreigebenBereich = schichtenFreigebenBereich;
toolbarFun.schichtenFreigebenMitarbeiter = schichtenFreigebenMitarbeiter;
toolbarFun.debounceUpdateTagesnotiz = debounceUpdateTagesnotiz;
toolbarFun.schichtenFreigebenWoche = schichtenFreigebenWoche;
toolbarFun.mitarbeiterAuswahlPosten = mitarbeiterAuswahlPosten;
toolbarFun.printDienstplan = printDienstplan;
toolbarFun.clickWochenauswahl = clickWochenauswahl;
toolbarFun.updateKWoptions = updateKWoptions;
toolbarFun.heute = heute;

// Relevante HTML Elemente auf die oft zugegriffen wird
const modal = document.getElementById('my-modal');
const schichtVorlageTemplate = document.querySelector('[template-schicht-vorlage-input]');

async function printDienstplan() {
    const chunkArray = (inputArray) => {
        const result = [];
        for (let i = 0; i < inputArray.length; i += 7) {
          result.push(inputArray.slice(i, i + 7));
        }
        return result;
    };
    // Wir müssen alle leeren Zeilen im Druck ausblenden...
    const gridItems = [...document.querySelectorAll('.daycell:not(.tot)')];
    // eine reihe besteht aus 7 Tages-Zellen (Mo-So)
    const gridRows = chunkArray(gridItems);
    // wir überprüfen ob jede reihe mindestens ein schicht element hat.
    for (const row of gridRows) {
        // Tagzellen-IDs haben die Form `${tag}:${postenID}:${ZeilenID}` (siehe dienstplan.js:addGridRow)
        // — daraus die Mitarbeiter-Namenszelle (`ma:${postenID}:${ZeilenID}`) derselben Zeile finden,
        // damit sie beim Ausblenden einer leeren Zeile mit ausgeblendet wird. Ohne das bleibt die
        // Namenszelle als einzelnes übriges Grid-Element stehen und verschiebt (Grid-Auto-Flow) alle
        // nachfolgenden Zeilen im Druck.
        const [, postenID, zeilenID] = row[0].id.split(':');
        const maZelle = document.getElementById(`ma:${postenID}:${zeilenID}`);
        // wenn es ein Schicht Element gibt, blenden wir es im Druck nicht aus.
        if (row.some((elem) => elem.querySelector('.schicht-div:not(.schicht-panel)') !== null)) {
            row.forEach((elem) => elem.classList.remove('hidden-print'));
            maZelle?.classList.remove('hidden-print');
        } else {
            row.forEach((elem) => elem.classList.add('hidden-print'));
            maZelle?.classList.add('hidden-print');
        }
    }
    // ausdrucken
    window.print();
}

/**
 * Wechselt die Kalenderwoche und lädt den Dienstplan
 * @param {int} wechselWert
 */
 async function wechsleWoche(wechselWert) {
    // Ladeanzeige übernimmt zeigeDienstplan() selbst (nur über dem Grid, siehe dp-grid-loader) —
    // kein globales toggleLoader() mehr nötig, das würde zusätzlich die ganze Seite abdunkeln.
    const grid = document.getElementById('grid');
    const eingeklappt = [...grid.querySelectorAll('.area-header-closed')].map((header) => header.id);
    const scrollTop = grid.scrollTop;
	datumService.wechsleWoche(wechselWert);
    await renderAktiveView();
    // gleiche Scrollhöhe
    grid.scrollTop = scrollTop;
    // Eingeklappte Posten- und Bereichs-Header wieder einklappen
    [...grid.querySelectorAll('.area-header, .bereich-header')].forEach((header) => {
        if (!eingeklappt.includes(header.id)) return;
        header.classList.add('area-header-closed');
        const id = header.id.split('-')[0];
        const selector = header.classList.contains('bereich-header') ? `[data-bereich="${id}"]` : `[aria-level="${id}"]`;
        document.body.querySelectorAll(selector).forEach((item) => item.classList.add('hidden'));
    });
}

/**
 * Springt zur Kalenderwoche der aktuellen Woche (heute).
 */
async function heute() {
	const heuteStart = dayjs.tz(new Date(), dayjs.tz.DEFAULT_TZ).startOf('week');
	const diffWochen = heuteStart.diff(datumService.laufendesDatum, 'week', false);
	if (!diffWochen) return;
	await wechsleWoche(diffWochen);
}

/**
 * Reagiert auf einen Wechsel des Bereichs im Vorlagen-Select der Sidebar. Seit dem Filter-Panel
 * steuert #bereich-select keine Sichtbarkeit im Dienstplan-Grid mehr (mehrere Bereiche können
 * gleichzeitig sichtbar sein) — es legt nur noch fest, welcher Bereich Schichtvorlagen für den
 * Vorlagen-Select in der Toolbar und die Vorlagenliste in der Sidebar liefert. Ein voller
 * zeigeDienstplan()-Reload wäre daher unnötig, deshalb rendern wir hier nur die Vorlagen neu.
 */
async function wechsleBereich() {
	await erstelleToolbarVorlagenSelect();
}

/**
 * Sortiert die Tabelle nach Namen der Mitarbeiter
 */
async function sortNamen() {
    const iconAZ = document.getElementById('sort-az');
    if (iconAZ.className === 'bi bi-sort-alpha-up') {
        stammdatenService.sort = 1;
        iconAZ.className = 'bi bi-sort-alpha-down';
    } else {
        stammdatenService.sort = -1;
        iconAZ.className = 'bi bi-sort-alpha-up';
    }
    renderAktiveView();
}

/**
 * Sortiert die Tabelle nach der Sortierreihenfolge der Mitarbeiter
 */
async function sortRank() {
    stammdatenService.sort = 0;
    renderAktiveView();
}

/**
 * Sortiert die Tabelle nach Personalnummer; erneuter Klick dreht die Richtung um (wie bei den Namen).
 */
async function sortPersonalnummer() {
    const icon = document.getElementById('sort-pnr');
    const aufsteigend = stammdatenService.sort !== 2;
    stammdatenService.sort = aufsteigend ? 2 : -2;
    icon.className = aufsteigend ? 'bi bi-sort-numeric-down' : 'bi bi-sort-numeric-up';
    renderAktiveView();
}

/**
 * Kopiert den aktuellen Dienstplan in die nächste Woche
 */
async function kopiereDienstplan() {
    // Ausgewählter Zeitraum
    const kwSelect = document.getElementById('kopieren-tb-select');
    const kwDifferenz = kwSelect.value;

    // Auswahl Mitarbeiter
    const mitarbeiterCheck = document.querySelectorAll('.ma-auswahl');
    const mitarbeiterAuswahl = [...mitarbeiterCheck].filter((ma) => ma.checked);
    // Wir wollen eine Liste an ausgewählten MitarbeiterIDs
    const mitarbeiterListe = [];
    // die MitarbeiterID ist im aria-label Attribut gespeichert.
    mitarbeiterAuswahl.forEach((ma) => mitarbeiterListe.push(ma.getAttribute('aria-label')));

    // ans backend Datum KW bis (aktuell) und von wann
    const kwDatumBis = datumService.laufendesDatum;
    const kwDatumVon = datumService.laufendesDatum.subtract(kwDifferenz, 'weeks');
    const result = await schichtenService.kopiereSchichtenKW(kwDatumVon.format('YYYY-MM-DD'), kwDatumBis.format('YYYY-MM-DD'), mitarbeiterListe);
    renderAktiveView();
    if (result === 200) {
        await SystemDialogService.instance.displayAsync('erfolg-schicht-copy-dialog');
    } else if (result === 404) {
        await SystemDialogService.instance.displayAsync('warnung-schicht-copy-dialog');
    } else {
        await SystemDialogService.instance.displayAsync('fehler-schicht-copy-dialog');
    }
}

/**
 * Rendert den Editor für die Bearbeitung von Vorlagen
 */
async function erstelleSchichtVorlagenInputFeld(vorlageID = '') {
    let value = vorlageID;
    const toolbarSelect = document.getElementById('vorlage-tb-select');
    if (!value) {
        value = toolbarSelect.value;
    } 
    // Falls die aktive Vorlage im Select nicht gleich dem Klick auf dem Sidebar Toolbtn ist, dann ändern.
    if (vorlageID !== '' && toolbarSelect.value !== vorlageID) {
        toolbarSelect.value = vorlageID;
    }
    // Wir verhindern, dass EGFZ Schichten bearbeitet werden können
    if (!isNaN(value) && _.values(Egfz).includes(parseInt(value, 10))) {
        zeigeKleineNachricht('EGFZ kann nicht bearbeitet werden!', 0);
        return;
    }

	const datum = datumService.laufendesDatum;
    const schicht = {
        Datum: datum,
		Zeitbloecke: [],
	};
	// Reset des Modals
	const modalText = document.getElementById('modal-text');
	modalText.innerHTML = '';

	// Kopieren des Templates
	const inputFeld = schichtVorlageTemplate.content.cloneNode(true).children[0];
    inputFeld.querySelector('#input-datum').innerText = schicht.Datum.format('DD.MM.YYYY');

	// Bereich-Auswahl der Vorlage — unabhängig von der Sidebar-Bereichsauswahl (#bereich-select) wählbar,
	// damit man eine Vorlage anlegen/bearbeiten kann, ohne vorher die Sidebar umzuschalten. Vorbelegt mit
	// der aktuellen Sidebar-Auswahl; beim Laden einer vorhandenen Vorlage unten auf deren echten Bereich
	// nachgezogen (siehe sammleSchichtDaten in schichtEditor.js für die Verwendung beim Speichern).
	const unternehmen = await stammdatenService.getUnternehmensdaten();
	const bereicheAktiv = unternehmen.Bereiche.filter((b) => b.Verwenden).sort((a, b) => a.Bereich.localeCompare(b.Bereich));
	const bereichSelect = inputFeld.querySelector('#input-vorlage-bereich');
	bereicheAktiv.forEach((b) => {
		const option = document.createElement('option');
		option.value = b._id;
		option.innerText = b.Bereich;
		bereichSelect.appendChild(option);
	});
	bereichSelect.value = document.getElementById('bereich-select').value;

	// Auswahl der bereits existierenden Vorlagen (gleiche nach Bereich gruppierte Suche wie im Schicht-Editor)
	const inputDiv = inputFeld.querySelector('#input-vorlagen');
	const bereichID = bereichSelect.value;
	// Hält die ID der aktuell geladenen Vorlage für speichereSchichtVorlage/loescheSchichtVorlage
	const vorlageIdInput = document.createElement('input');
	vorlageIdInput.type = 'hidden';
	vorlageIdInput.id = 'input-vorlage';
	inputDiv.appendChild(vorlageIdInput);
	const vorlagenPicker = await renderVorlagenPicker(inputDiv, bereichID, (vorlage) => {
		vorlageIdInput.value = vorlage._id;
		wendeVorlageAn(vorlage, inputFeld, '#input-vorlage-titel');
		// Bereich-Select auf den tatsächlichen Bereich der geladenen Vorlage nachziehen — kann von der
		// aktuellen Sidebar-Auswahl abweichen (die Vorlagenliste zeigt bewusst alle Bereiche, nicht nur den).
		if (vorlage.BereichID) bereichSelect.value = vorlage.BereichID;
	}, {
		zeigeSchnellauswahl: false,
		// "Neue Vorlage anlegen …": nur die _id-Bindung kappen (Speichern legt dann ein neues Dokument an,
		// siehe schichtEditor.js:speichereSchichtVorlage), die restlichen Felder bleiben unangetastet —
		// so kann man bewusst von einer bereits geladenen Vorlage ausgehen und sie als neue speichern.
		onNeueVorlage: () => { vorlageIdInput.value = ''; },
	});

   	// Input für ganztags
	const inputGanztags = inputFeld.querySelector('#input-schicht-ganztags');
    inputGanztags.checked = schicht.Ganztags ?? false;
	// Input für offener Beginn
	const inputOffenerBeginn = inputFeld.querySelector('#input-schicht-offener-beginn');
	inputOffenerBeginn.checked = schicht.OffenerBeginn ? schicht.OffenerBeginn : false;
	inputOffenerBeginn.addEventListener('input', () => {
		if (!inputOffenerBeginn.checked) {
			inputGanztags.checked = false;
		}
		// Falls wir die checkbox auf true gesetzt haben, blenden wir einen Zeitblock mit Sollstunden ein.
		// ...außer es wurden mehrere Zeitblöcke definiert (<=2 da die erste table row die Titelzeile ist)
		if (inputOffenerBeginn.checked && zeitblockAnzahl() <= 1) {
			offenerZeitblock(schicht, false, undefined);
		}
	});
	// Input für offenes Ende
	const inputOffenesEnde = inputFeld.querySelector('#input-schicht-offenes-ende');
	inputOffenesEnde.checked = schicht.OffenesEnde ? schicht.OffenesEnde : false;
	inputOffenesEnde.addEventListener('input', () => {
		if (!inputOffenesEnde.checked) {
			inputGanztags.checked = false;
		}
		// Falls wir die checkbox auf true gesetzt haben, blenden wir einen Zeitblock mit Sollstunden ein.
		// ...außer es wurden mehrere Zeitblöcke definiert (<=2 da die erste table row die Titelzeile ist)
		if (inputOffenesEnde.checked && zeitblockAnzahl() <= 1) {
			offenerZeitblock(schicht, true, undefined);
		}
	});


	inputGanztags.checked = schicht.Ganztags ? schicht.Ganztags : false;
	inputGanztags.addEventListener('input', () => {
		if (inputGanztags.checked) {
			inputOffenerBeginn.checked = true;
			inputOffenesEnde.checked = true;
		}
		// ...außer es wurden mehrere Zeitblöcke definiert (<=2 da die erste table row die Titelzeile ist)
		if (inputGanztags.checked && zeitblockAnzahl() <= 1) {
			offenerZeitblock(schicht, false, undefined, true);
		}
	});

    // SchichtFarbe übernehmen
    inputFeld.querySelector('#input-schicht-farbe').value = schicht.SchichtFarbe ? schicht.SchichtFarbe : '#0071bd';
    // Schicht Notiz übernehmen
	inputFeld.querySelector('#input-schicht-notiz').value = schicht.SchichtNotiz ? schicht.SchichtNotiz : '';
	initFarbSwatches(inputFeld);
	initArtSegment(inputFeld);

    // Vorlage Button Event Handlers
    const vorlageSubmit = inputFeld.querySelector('#vorlage-submit');
	vorlageSubmit.addEventListener('click', async () => speichereSchichtVorlage(schicht));
    const vorlageDelete = inputFeld.querySelector('#vorlage-delete');
    vorlageDelete.addEventListener('click', async () => loescheSchichtVorlage());

    // Zeige das befüllte Input Feld an
    modalText.appendChild(inputFeld);
	modal.style.display = 'block';

    // Erstelle Zeitblock Input
    if (toolbarSelect.value !== '') {
        // Übernehmen der Attribute aus der ausgewählten Vorlage...
        const vorlage = await schichtenService.holeSchichtObjekt(toolbarSelect.value);
        vorlageIdInput.value = toolbarSelect.value;
        wendeVorlageAn(vorlage, inputFeld, '#input-vorlage-titel');
        inputFeld.querySelector('#input-schicht-notiz').value = vorlage.SchichtNotiz ? vorlage.SchichtNotiz : '';
        if (vorlage.BereichID) bereichSelect.value = vorlage.BereichID;
        vorlagenPicker.setzeAktiveVorlage(toolbarSelect.value);
    } else {
        erstelleZeitblockTabelle(schicht, 0);
    }
}

/**
 * Update der Tagesnotiz
 * @param {HTMLElement} thisElement HTML Input Element
 */
async function updateTagesNotiz(thisElement) {
    // Wochentag ist in der ID gespeichert notiz:wochentag, z.B. notiz:1 ist Montag
    const wochentag = parseInt(thisElement.parentNode.id.split(':')[1], 10);
    // das Datum muss dem laufendem Datum + Wochentag sein. (+0 falls montag, +6 falls sonntag)
    const datumInput = datumService.laufendesDatum.add(wochentag - 1, 'days');
    const betriebsstaetteID = document.getElementById('select-betriebsstaette').value;
    if (betriebsstaetteID.value === '') {
        zeigeKleineNachricht('Keine Betriebsstätte ausgewählt!', -1);
        return;
    }
    const notiz = thisElement.value;
    await stammdatenService.fetchUpdateTagesNotiz(notiz, datumInput.format('YYYY-MM-DD'), betriebsstaetteID);
}

/**
 * Klick Handler, der das Freigaben der Schichten eines Postens einleitet.
 * @param {string} postenID
 */
async function schichtenFreigebenWoche(postenID) {
    const betriebsstaetteID = document.getElementById('select-betriebsstaette').value;
    const wocheStart = datumService.laufendesDatum.startOf('week').format('YYYY-MM-DD');
    const wocheEnde = datumService.laufendesDatum.endOf('week').format('YYYY-MM-DD');
    const result = await schichtenService.freigabeSchichten(postenID, wocheStart, wocheEnde, betriebsstaetteID);
    if (!result) {
        return;
    }
    // nun alle Schichten des Postens als freigeben markieren
    // 1. Schritt alle Schichten des Postens finden...
    // Die Kopierquelle-Vorschau hat zwar die gleiche aria-description, aber kein [schicht-freigabe-status] Element -> ausschließen.
    const schichtenPostenHTML = [...document.querySelectorAll(`[aria-description="${postenID}"]:not(.kopier-quelle-vorschau)`)];
    // 2. Schritt alle Freigeben Circle Icons updaten
    // Nur die Klasse des Freigabe-<i> ändern statt innerHTML neu zu setzen, sonst geht der Kopier-Button (+ Listener) verloren.
    schichtenPostenHTML.forEach((schicht) => {
        const freigabeIcon = schicht.querySelector('[schicht-freigabe-status] > i');
        if (!freigabeIcon) return;
        freigabeIcon.classList.remove('bi-circle');
        freigabeIcon.classList.add('bi-circle-fill');
        freigabeIcon.title = 'Schicht freigegeben';
    });
}

/**
 * Gibt alle noch nicht freigegebenen Schichten eines ganzen Bereichs frei (alle Posten des Bereichs
 * auf einmal, nicht nur einer). Anders als schichtenFreigebenWoche patchen wir die Freigabe-Icons
 * nicht einzeln, sondern rendern den Dienstplan komplett neu — ein Bereich kann mehrere Posten
 * umfassen, ein gezielter DOM-Patch über alle betroffenen Karten wäre hier unnötig komplex.
 * @param {string} bereichID
 */
async function schichtenFreigebenBereich(bereichID) {
    const betriebsstaetteID = document.getElementById('select-betriebsstaette').value;
    const wocheStart = datumService.laufendesDatum.startOf('week').format('YYYY-MM-DD');
    const wocheEnde = datumService.laufendesDatum.endOf('week').format('YYYY-MM-DD');
    const result = await schichtenService.freigabeSchichtenBereich(bereichID, wocheStart, wocheEnde, betriebsstaetteID);
    if (!result) {
        return;
    }
    await zeigeDienstplan(true);
}

/**
 * Klick Handler für den Freigabe-Button der Mitarbeiteransicht (siehe views/mitarbeiteransichtView.js).
 * Anders als bei Posten/Bereich gibt es hier keine feste Gruppe: sind Mitarbeitende über die
 * `.ma-auswahl`-Checkboxen ihrer Zeile ausgewählt, werden nur deren Schichten freigegeben; ist niemand
 * ausgewählt, fragt ein Bestätigungsdialog nach, ob für alle aktuell sichtbaren (d.h. Filter-Panel-
 * gefilterten) Mitarbeitenden freigegeben werden soll — bewusst mit Rückfrage, da diese Variante eine
 * größere, nicht durch eine explizite Auswahl eingegrenzte Wirkung hat.
 */
async function schichtenFreigebenMitarbeiter() {
    const alleCheckboxen = [...document.querySelectorAll('#magrid-content .ma-auswahl')];
    if (alleCheckboxen.length === 0) {
        return;
    }
    const ausgewaehlt = alleCheckboxen.filter((checkbox) => checkbox.checked);
    let mitarbeiterIDs = ausgewaehlt.map((checkbox) => checkbox.getAttribute('aria-label'));
    if (mitarbeiterIDs.length === 0) {
        document.getElementById('freigabe-mitarbeiter-dialog').querySelector('.nachricht-info').innerText =
            `Es sind keine Mitarbeitenden ausgewählt. Sollen alle ${alleCheckboxen.length} aktuell sichtbaren Mitarbeitenden freigegeben werden?`;
        const dialogResult = await SystemDialogService.instance.displayAsync('freigabe-mitarbeiter-dialog');
        if (!dialogResult.success) {
            return;
        }
        mitarbeiterIDs = alleCheckboxen.map((checkbox) => checkbox.getAttribute('aria-label'));
    }
    const betriebsstaetteID = document.getElementById('select-betriebsstaette').value;
    const wocheStart = datumService.laufendesDatum.startOf('week').format('YYYY-MM-DD');
    const wocheEnde = datumService.laufendesDatum.endOf('week').format('YYYY-MM-DD');
    const result = await schichtenService.freigabeSchichtenMitarbeiter(mitarbeiterIDs, wocheStart, wocheEnde, betriebsstaetteID);
    if (!result) {
        return;
    }
    await renderAktiveView();
}

function mitarbeiterAuswahlPosten(postenID) {
    const mitarbeiterChecks = [...document.querySelectorAll(`input[aria-level="${postenID}"]`)];
    const alreadyChecked = mitarbeiterChecks.every((ma) => ma.checked);
    mitarbeiterChecks.forEach((checkbox) => {
        checkbox.checked = !alreadyChecked;
    });
}

async function clickWochenauswahl() {
    const jahr = datumService.laufendesDatum.year();
    const kw = datumService.kalenderWoche;
    document.getElementById('dialog-kal-year').value = jahr;
    updateKWoptions(jahr, kw);
    const result = await SystemDialogService.instance.displayAsync('kalender-woche-dialog');
    if (result.success) {
        const dateFromWeek = datumService.laufendesDatum.year(result.data.Year).week(result.data.Week);
        const diffWeeks = dateFromWeek.diff(datumService.laufendesDatum, 'week', false);
        console.log(diffWeeks);
        if (!diffWeeks) return;
        wechsleWoche(diffWeeks);
    }
}

function updateKWoptions(year, kw) {
    const kalWeekInput = document.getElementById('dialog-kal-week');
    const prev = kw || kalWeekInput.value;
    kalWeekInput.innerHTML = '';
    const weeksInYear = dayjs(`${year}-01-01`).isoWeeksInYear();
    let tmpDate = dayjs(`${year}-01-01`);
    for (let i = 1; i <= dayjs(`${year}-01-01`).isoWeeksInYear(); i++) {
        const option = document.createElement('option');
        option.value = i;
        option.innerText = `KW ${i} (${tmpDate.startOf('week').tz().format('DD.MM.YYYY')} - ${tmpDate.endOf('week').tz().format('DD.MM.YYYY')})`;
        kalWeekInput.appendChild(option);
        tmpDate = tmpDate.add(1, 'weeks');
    }
    kalWeekInput.value = Math.min(weeksInYear, prev);
}

export { toolbarFun };
